var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoKenvue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#009000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2704_38875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.23077 9.6499V22.3157H14.4667V15.9869V9.6499H9.23077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6651 15.9864L22.1902 13.7109C22.5735 13.14 22.7611 12.6262 22.7611 11.9819C22.7611 10.6525 21.6927 9.48627 20.1757 9.48627C19.1236 9.48627 18.3652 9.98376 17.7127 10.9951L14.4667 15.9864L17.7127 20.9776C18.3652 21.9889 19.1236 22.4864 20.1757 22.4864C21.6927 22.4864 22.7611 21.3202 22.7611 19.9908C22.7611 19.3465 22.5735 18.8327 22.1902 18.2618L20.6651 15.9864Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2704_38875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5385,
    height: 13.0491,
    fill: "white",
    transform: "translate(9.23077 9.47525)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKenvue);
export default __webpack_public_path__ + "static/media/logo-kenvue.ca1246c1a6f6be84ebb49c028347ba71.svg";
export { ForwardRef as ReactComponent };